// import store2 from 'store2';  //old implement before shared lib
import { storeHelper } from '@ajaibid/utils';

// export const authStorage = store2.namespace('auth');
export const authStorage = storeHelper('auth');

// export const kycStorage = store2.namespace('kyc');
export const kycStorage = storeHelper('kyc');

// export const transactionStorage = store2.namespace('trans');
export const transactionStorage = storeHelper('trans');

// export const genericStorage = store2.namespace('generic');
export const genericStorage = storeHelper('generic');
